module.exports = __webpack_public_path__ + "static/media/scLogo.0aaeaf2a.png";